import { User } from './user'
import { FeathersModel } from './feathersModel'
import { DateUtils } from '../services/date-utils.service'
import { createIntlComparer, DEFAULT_LOCALES } from '../services/utils'

// See https://coryrylan.com/blog/rich-domain-models-with-typescript

export class Client extends FeathersModel {
  static serviceName = 'clients'
  static intlSortComparer = createIntlComparer(DEFAULT_LOCALES, {
    sensitivity: 'accent',
  })

  dependenceLevelId: number
  preferredGenderId: number // preference pohlavi pri asistenci
  keyCoordinatorId: number // klicovy pracovnik - user s roli coordinator
  keyCoordinator: User
  benefitsCardTypeId: number
  userId: string
  childrenCount: number
  coordinatorNote: string
  contractedAssistanceHoursPerWeek: number
  legalCapacity: string
  legalCapacityNote: string
  needsStrongAssistant: boolean
  // cooperationStartDate: Date
  cooperationStartDate: number
  needsAdvancedAssistant: boolean
  deactivatedAt: Date
  deactivationReason: string
  targetGroupOkSystemCode: number

  user: User

  static sortByName(a: Client, b: Client) {
    return Client.intlSortComparer(a.user.lastName + ' ' + a.user.firstName, b.user.lastName + ' ' + b.user.firstName)
  }

  get title(): string {
    return this.user.title
  }

  get birthDate(): string | Date {
    return this.user.birthDate
  }

  get genderId(): number {
    return this.user.genderId
  }

  get idCardNumber(): string {
    return this.user.idCardNumber
  }

  get nationalityId(): number {
    return this.user.nationalityId
  }

  get maritalStatusId(): number {
    return this.user.maritalStatusId
  }

  get address_street(): string {
    return this.user.address_street
  }

  get address_houseNumber(): string {
    return this.user.address_houseNumber
  }

  get address_city(): string {
    return this.user.address_city
  }

  get address_postcode(): string {
    return this.user.address_postcode
  }

  get address_orp(): string {
    return this.user.address_orp
  }

  set title(title: string) {
    this.user.title = title
  }

  set birthDate(birthDate: string | Date) {
    this.user.birthDate = birthDate
  }

  set genderId(genderId: number) {
    this.user.genderId = genderId
  }

  set idCardNumber(idCardNumber: string) {
    this.user.idCardNumber = idCardNumber
  }

  set nationalityId(nationalityId: number) {
    this.user.nationalityId = nationalityId
  }

  set maritalStatusId(maritalStatusId: number) {
    this.user.maritalStatusId = maritalStatusId
  }

  set address_street(address_street: string) {
    this.user.address_street = address_street
  }

  set address_houseNumber(address_houseNumber: string) {
    this.user.address_houseNumber = address_houseNumber
  }

  set address_city(address_city: string) {
    this.user.address_city = address_city
  }

  set address_postcode(address_postcode: string) {
    this.user.address_postcode = address_postcode
  }

  set address_orp(address_orp: string) {
    this.user.address_orp = address_orp
  }

  turnSubresourcesIntoFrontendModels() {
    this.user = this.user ? User.createFromProps(User, this.user) : this.user
    this.keyCoordinator = this.keyCoordinator ? User.createFromProps(User, this.keyCoordinator) : this.keyCoordinator
  }

  isDeactivated() {
    return DateUtils.canBeParsedToDate(this.deactivatedAt)
  }

  get fullname(): string {
    return this.user.fullName()
  }
}
